'use strict';
var win                     = require( '@rei/browser-shim' ).win;
var $                       = require( 'jquery' );
var moment                  = require( 'moment' );
var doc                     = win.document;

// In Order to Subscribe Slugs to Pushstate Changes
var windowEvents            = require( '@rei/window-events' );
var pushstateChange         = windowEvents.pushstateChangeFunctions;
var replaceStateChange      = windowEvents.replaceStateChangeFunctions;

// Subscribe to Click Events
var clickEvents             = require( '@rei/click-event-pubsub' );
var inputEvents             = clickEvents.inputEvents;
var selectEvents            = clickEvents.selectEvents;
var anchorOrButtonEvents    = clickEvents.anchorOrButtonEvents;
var formEvents              = clickEvents.formEvents;
var getElementFromEvent     = clickEvents.getElementFromEvent;

// Param Utilities
var paramManager            = require( '@rei/query-param-manager' );
var getPathName             = paramManager.getPathName;
var setPathName             = paramManager.setPathName;
var getQueryString          = paramManager.getQueryString;
var addQueryParam           = paramManager.addQueryParam;
var changeQueryParam        = paramManager.changeQueryParam;
var replaceQueryParam       = paramManager.replaceQueryParam;
var removeQueryParams       = paramManager.removeQueryParams;
var removeMatchedQueryParam = paramManager.removeMatchedQueryParam;
var pushStatePageChange     = paramManager.pushStatePageChange;

// Fallback slug when specified in trackedSlugs
var defaultSlug             = {};

// Utility to parseBoolean from strings
var parseBoolean = function ( val ) {
    return ( val == 'true' || val == true );
};

var isPushpopElement = function ( element ) {
    if ( !element ) return false;
    /*
     * Parameter Checking
     */
    var hasPushpopParam         = element.hasAttribute( 'data-pushpop-param' );
    var hasPushpopParamOptions  = element.hasAttribute( 'data-pushpop-remove-params' );

    // Detect if we should grab value from another element
    if ( hasPushpopParam ) {

        var pushpopParam        = element.getAttribute( 'data-pushpop-param' );
        var idDetected          = pushpopParam.startsWith( '#' );

        // Remove Hash for Element Lookup
        if ( idDetected ) {

            var otherElement    = doc.getElementById( pushpopParam.substring( 1 ) );

            if ( otherElement ) pushpopElement( otherElement );

            return false;
        }
    }

    /*
     * Slug Checking
     */
    var hasPushpopSlug              = element.hasAttribute( 'data-pushpop-slug');
    var hasPushpopSlugOptions       = element.hasAttribute( 'data-pushpop-remove-slugs' );

    if ( hasPushpopSlug ) {
        var slugToPop               = element.getAttribute( 'data-pushpop-slug' );

        // Detect if we should grab value from another element
        var idDetected              = slugToPop ? slugToPop.startsWith("#") : false;

        if ( idDetected ) {

            // Remove Hash for Element Lookup
            var otherElement        = doc.getElementById( slugToPop.substring( 1 ) );
            var pushpopSlugOptions  = element.getAttribute( 'data-pushpop-remove-slugs' );

            if ( otherElement ) {

                var otherSlugValue  = getPushpopSlugValue( otherElement );

                if ( otherElement && otherSlugValue ) pushpopElement( otherElement );

                if ( pushpopSlugOptions ) executeSlugOptions( otherElement );

            }
            return false;
        }
    }

    return hasPushpopParam || hasPushpopSlug || hasPushpopParamOptions || hasPushpopSlugOptions;
};

var hasPushpopOptions = function ( element ) {
    if ( !element ) return;
    var removeParams    = element.hasAttribute( 'data-pushpop-remove-params' );
    var replaceParams   = element.hasAttribute( 'data-pushpop-replace-param' );
    var removeSlugs     = element.hasAttribute( 'data-pushpop-remove-slugs'  );
    var pushpopOther    = element.hasAttribute( 'data-pushpop-element-by-id' );
    return removeParams || replaceParams || removeSlugs || pushpopOther;
};


/*
*
*
* Pushpop Param Methods
*
*
*/
var getPushpopParamName = function ( element ) {
    if ( !element ) return;

    // Check for pushpop param attribute first or get attribute from name attribute
    var paramName = element.getAttribute( 'data-pushpop-param' );

    if ( paramName === 'name' ) {
        paramName = element.name || 'nullParam';
    }

    return paramName;
};

var appendValue = function ( element, paramValue) {
    if ( !element ) return;

    var appendToValue = element.getAttribute( 'data-pushpop-append-to-value');

    if ( appendToValue ) {
        paramValue += appendToValue;
    }

    return paramValue;
};

var getPushpopParamValue = function ( element ) {
    if ( !element ) return;

    var paramValue      = element.value;
    var pushpopValue    = element.getAttribute( 'data-pushpop-param-value' );

    if ( pushpopValue ) {
        paramValue      = pushpopValue;
    }

    paramValue = appendValue( element, paramValue );

    //remove any < / > from the input if value exists. safeguarding text fields and possible data-* manipulation

    if( paramValue ) {
        paramValue = paramValue.toString().replace(/<[^>]+>/g, '');
    }

    return paramValue;
};

var executeParamOptions = function ( queryString, element, paramName, paramValue ) {
  	if ( !element ) return;

    if ( paramName && !paramValue || paramName && paramValue === '' ) {
        queryString             = removeQueryParams( queryString, paramName );
    }

    var replaceParam            = element.getAttribute( 'data-pushpop-replace-param' );
    if ( replaceParam ) {
        var remappedParams      = replaceParam.split( ':' );
        var originalParamName   = remappedParams[ 0 ].trim();
        var newParamName        = remappedParams[ 1 ].trim();
        queryString             = replaceQueryParam( queryString, originalParamName, newParamName, paramValue );
    }

    var removeParam             = element.getAttribute( 'data-pushpop-remove-params');
    if ( removeParam ) {
        var paramsToRemove      = removeParam.split( ',' );
        paramsToRemove          = paramsToRemove.map( function ( i ) {
            return i.trim();
        });
        queryString             = removeQueryParams( queryString, paramsToRemove );
    }

    var pushpopOther            = element.getAttribute( 'data-pushpop-element-by-id' );
    if ( pushpopOther ) {
        var otherElement        = doc.getElementById( pushpopOther );
        var cleanedQueryString  = pushpopElement( otherElement, 'queryString', queryString );
        queryString             = cleanedQueryString;
    }

    var scrollToID              = element.getAttribute( 'data-pushpop-scroll-to' );
    if ( scrollToID ) {
        var scrollToElement     = doc.getElementById( scrollToElement );
        if ( scrollToElement ) {
            scrollToElement.scrollIntoView();
        } else {
            win.scrollTo( 0, 0 );
        }
    }

    return queryString;
};

/*
 *
 *
 * Pushpop Slug Methods
 *
 *
 */

var slugs                   = {};
var rootPath                = null;

var setRootPath = function ( newRoot ) {
    rootPath = newRoot;
};

var clearRootPath = function () {
    rootPath = null;
};

var getPushpopSlugName = function ( element ) {
    if ( !element ) return;

    // Check for pushpop param attribute first or get attribute from name attribute
    var slugName = element.getAttribute( 'data-pushpop-slug' );

    if ( slugName === 'name' ) {
        slugName = element.name || 'nullSlug';
    }

    return slugName;
};

var getPushpopSlugValue = function ( element ) {
  	if ( !element ) return;
    var slugValue       = element.value;

    var pushpopValue    = element.getAttribute( 'data-pushpop-slug-value' );
    if ( pushpopValue ) {
        slugValue = pushpopValue;
    }

    var appendValue     = element.getAttribute( 'data-pushpop-append-to-value');
    if ( appendValue ) {
        slugValue += appendValue;
    }
    return slugValue;
};

var changeSlug = function ( slug, slugType, slugValue, order ) {

    if ( !slug ) return;

    // Create Slug Object or Clear Existing Object
    slugs[ slug ]           = {};
    slugs[ slug ].name      = slug;
    slugs[ slug ].type      = slugType ? slugType : 'pair';

    if ( slugValue ) {
        slugs[ slug ].value = slugValue;
    } else {
        slugs[ slug ].type  = slugType ? slugType : 'directory';
    }

    if ( order ) {
        slugs[ slug ].order = parseInt( order );
    }
};

var deleteSlug = function ( slugName ) {

    var validSlug = slugs[ slugName ];

    if ( validSlug ) {
        delete slugs[ slugName ];
    }
};

var executeSlugOptions = function ( element ) {
    if ( !element ) return;

    var removeSlugs         = element.getAttribute( 'data-pushpop-remove-slugs' );

    if ( removeSlugs ) {
        var slugsToRemove   = removeSlugs.split( ',' );

        slugsToRemove       = slugsToRemove.map( function ( i ) {
            return i.trim();
        });

        slugsToRemove.forEach( function ( slugToRemove ) {
            delete slugs[ slugToRemove ];
        });

        if ( Object.keys( slugs ).length < 1 && defaultSlug.name ) {
            slugs[ defaultSlug.name ] = defaultSlug;
        }

    }
};

var getSlugPath = function () {

    var slugArray = [];

    for ( var slugName in slugs ) {

        slugArray.push( slugs[ slugName ] );

    }

    slugArray.sort( function( slug1, slug2 ) {

        // Sort by order, if null set a high value
        slug1.order = slug1.order || 999;
        slug2.order = slug2.order || 999;

        return slug1.order - slug2.order;
    });


    var pathName = "";

    if ( rootPath ) pathName += rootPath;

    slugArray.forEach( function ( slug ) {

        pathName += '/' +slug.name;

        if ( slug.value ) pathName += '/' + slug.value;

    });

    return pathName;
};

var updateSlugsFromPathname = function ( ) {

    var pathname = location.pathname;
    var urlParts = pathname.split( '/' );

    // update new slugs based on tracked slugs that are preserved on call of trackSlugs
    preservedSlugs.forEach( function ( trackedSlug ) {
        var indexOfSlug = urlParts.indexOf( trackedSlug.name );
        if ( indexOfSlug > 0 || trackedSlug.type == 'default' ) {
            var trackedSlugValue = urlParts[ indexOfSlug + 1 ];
            changeSlug( trackedSlug.name, trackedSlug.type, trackedSlugValue, trackedSlug.order )
        }
    } );

    setPathName( pathname );

};

var removeDeadSlugs = function () {

    var pathname                    = location.pathname;
    var urlParts                    = pathname.split( '/' );

    for ( var slug in slugs ) {

        var slugType                = slugs[ slug ].type;
        var slugValue               = slugs[ slug ].value;
        var slugKey                 = slugs[ slug ].name;
        var slugIndex               = urlParts.indexOf( slugKey );

        if ( slugType === 'pair' ) {

            var slugPairPath        = '/' + slugKey + '/' + slugValue;
            var regex               = new RegExp( slugPairPath, 'g');
            var isSlugPairActive    = pathname.match( regex );

            if ( !isSlugPairActive ) deleteSlug( slugKey );

        } else {

            var slugPath            = '/' + slugKey;
            var regex               = new RegExp( slugPath, 'g' );
            var isSlugActive        = pathname.match( regex );

            if ( !isSlugActive ) {
                deleteSlug( slugKey );
            }

        }
    }

};

// If a slug is on the list and found in the url, it will be preserved.
var preservedSlugs  = [];
var trackSlugs      = function ( arrayOfSlugs ) {

    var pageLoadedPath = getPathName().split('/');

    arrayOfSlugs.forEach( function ( trackedSlug ) {

        preservedSlugs.push( trackedSlug );

        var indexOfSlug = pageLoadedPath.indexOf( trackedSlug.name );

        if ( indexOfSlug > 0 || trackedSlug.type == 'default' ) {

            // Store Default In Memory if Exists in the event all slugs are cleared
            if ( trackedSlug.type == 'default' && trackedSlug.name ) {
                defaultSlug = trackedSlug;
            }

            var trackedSlugValue = pageLoadedPath[ indexOfSlug + 1 ];

            changeSlug( trackedSlug.name, trackedSlug.type, trackedSlugValue, trackedSlug.order )
        }

    } );
};

/*
 *
 *
 * Pushpop Anchor, Button, Input, and Select Event Methods
 *
 *
 */

var pushPopAnchorOrButtonEvents = function ( e, subscribedElement ) {

    if ( e.type === 'click' && subscribedElement && isPushpopElement( subscribedElement ) || hasPushpopOptions( subscribedElement ) ) {

        // Prevent Default Anchor Action
        e.preventDefault();

        pushpopElement( subscribedElement );

    }

};

var pushpopSelects = function ( element ) {
  	if ( !element ) return;

    element.onchange = function () {

        var queryString         = getQueryString();
        var paramName           = getPushpopParamName( element );

        // Pollyfill for selectedIndex
        var targetElement       = ( typeof this.selectedIndex === 'undefined' ? win.event.srcElement : this );
        var paramValue          = getPushpopParamValue( targetElement ) || getPushpopParamValue( targetElement.options[ targetElement.selectedIndex ] );

        // Swaps a param name for another
        var selectedOption      = targetElement.options[ targetElement.selectedIndex ];

        if ( isPushpopElement( element ) ) queryString = changeQueryParam( queryString, paramName, paramValue );

        // Check select element for cleanup params
        queryString = executeParamOptions( queryString, element, paramName, paramValue );

        // Check Options for cleanup params too
        queryString = executeParamOptions( queryString, selectedOption, paramName, paramValue );

        var slug                = getPushpopSlugName( element );
        var slugValue           = getPushpopSlugValue( element );

        executeSlugOptions( element );
        executeSlugOptions( targetElement );


        var slugType            = slugValue ? 'pair' : 'directory';
        var slugOptionValue     = getPushpopSlugValue( targetElement ) || getPushpopSlugValue( targetElement.options[ targetElement.selectedIndex ] );
        var slugOrder           = element.getAttribute( 'data-pushpop-slug-order' );

        if ( slugOptionValue ) slugValue = slugOptionValue;

        // Change or Update
        changeSlug( slug, slugType, slugValue, slugOrder );

        var pathString          = getSlugPath();
        pushStatePageChange( queryString, pathString, rootPath );

    };

};

var pushpopSelectEvents = function ( e, subscribedElement ) {

    if ( subscribedElement && isPushpopElement( subscribedElement ) || hasPushpopOptions( subscribedElement ) ) {
        pushpopSelects( subscribedElement );
    }

};

var pushpopElement = function ( element, returnType, queryString ) {
	if ( !element ) return;

    var newQueryString = '';
    if ( returnType === 'queryString' ) {
        newQueryString  += queryString;
    } else {
        newQueryString  += getQueryString();
    }

    var paramName           = getPushpopParamName( element );
    var paramValue          = getPushpopParamValue( element );

    if ( paramName && paramValue ) {
        newQueryString      = changeQueryParam( newQueryString, paramName, paramValue );
    }

    newQueryString          = executeParamOptions( newQueryString, element, paramName, paramValue );

    var slug                = getPushpopSlugName( element );
    var slugValue           = getPushpopSlugValue( element );
    var slugOrder           = element.getAttribute( 'data-pushpop-slug-order' );
    var slugType            = slugValue ? 'pair' : 'directory';

    removeDeadSlugs();
    changeSlug( slug, slugType, slugValue, slugOrder );
    executeSlugOptions( element );

    var pathString          = getSlugPath();

    if ( returnType === 'queryString' ) {
        return newQueryString;
    } else if ( returnType === 'pathString' ) {
        return pathString;
    } else {
        pushStatePageChange( newQueryString, pathString, rootPath );
    }

};

var pushpopInputs = function ( e, element ) {

    if ( element && isPushpopElement( element ) ) {

        var queryString     = getQueryString();
        var inputType       = element.getAttribute( 'type' );
        var paramName       = getPushpopParamName( element );
        var paramValue      = null;

      	var updateParam = function () {
          	paramValue  = getPushpopParamValue( element );
          	queryString = changeQueryParam( queryString, paramName, paramValue );
            pushStatePageChange( queryString );
        };

        if (inputType === 'number'         ||
            inputType === 'button'         ||
            inputType === 'email'          ||
            inputType === 'tel  '          ||
            inputType === 'time'           ||
            inputType === 'month'          ||
            inputType === 'time'           ||
            inputType === 'datetime-local' ||
            inputType === 'url'            ||
            inputType === 'range'          ||
            inputType === 'search'         ||
            inputType === 'reset'          ||
            inputType === 'submit' ) {

            /*
             @TODO: Build method to handle other input types based on behavior triggers like change, blur, ect.
             You can currently trigger these elements with another button or element using the
             data-pushpop-element-by-id="other-element-id" as a user initiated mechanism to push input values.
             */

        }

        if ( ( e.type === 'click' || e.type === 'onfocus' ) && inputType === 'text' ) {

            element.onkeyup = function( event ) {
                if ( event.keyCode === 13 ) {
                    updateParam( element );

                  	// Prevent Form Submission/Page Refresh
                  	return false;
                }
            };

        }

        if ( ( e.type === 'click' || e.type === 'onfocus' ) && inputType === 'checkbox' ) {

            var isChecked   = element.checked;
            paramValue      = getPushpopParamValue( element );

            if ( isChecked ) {
                queryString = addQueryParam( queryString, paramName, paramValue );
            } else {
                queryString = removeMatchedQueryParam( queryString, paramName, paramValue );
            }

            queryString = executeParamOptions( queryString, element, paramName, paramValue );
            pushStatePageChange( queryString );

        }

        if ( ( e.type === 'click' || e.type === 'onfocus' ) && inputType === 'radio' ) {

            var isChecked   = element.checked;
            paramValue      = getPushpopParamValue( element );

            if ( isChecked ) {
                queryString = changeQueryParam( queryString, paramName, paramValue );
            } else {
                queryString = removeQueryParams( queryString, paramName );
            }

            queryString = executeParamOptions( queryString, element, paramName, paramValue );
            pushStatePageChange( queryString );

        }

        // Input values based on events
        if ( ( e.type === 'click' || e.type === 'onfocus' ) && inputType === 'date' ) {

            var updateDateInput = function () {
                /*
                 * date behaviors
                 */

                paramValue                  = element.value;

                if ( paramValue ) {

                    var pattern             = element.getAttribute( 'data-pushpop-pattern' );
                    var dateEndOf           = element.getAttribute( 'data-pushpop-date-end-of');
                    var momentDate;

                    if ( dateEndOf ) {
                        momentDate          = moment.utc( paramValue ).endOf( dateEndOf ).format( pattern ? pattern : null );
                    } else {
                        momentDate          = moment.utc( paramValue ).format( pattern ? pattern : null );
                    }

                    var validDate           = moment( momentDate ).isValid();

                    if ( validDate ) {

                        var partialEncodedUriDate  = momentDate.replace( '+', '%2B' );

                        // Check for append options and apply if needed
                        paramValue          = appendValue( element, partialEncodedUriDate );
                        queryString         = changeQueryParam( queryString, paramName, paramValue );

                    }

                }

                queryString = executeParamOptions( queryString, element, paramName, paramValue );
                pushStatePageChange( queryString );

            };

            element.onchange = function () {
                updateDateInput();
            };

            element.onkeyup = function( event ) {
                if ( event.keyCode == 13 ) {
                    updateDateInput();
                }
            };

        }

    }

};

var pushpopInputEvents = function ( e, subscribedElement ) {

    if ( subscribedElement && isPushpopElement( subscribedElement ) || hasPushpopOptions( subscribedElement ) ) {
        pushpopInputs( e, subscribedElement );
    }

};

var pushpopForms = function ( e, subscribedElement ) {

    // Prevent Form Submission
    if ( e.type === 'submit' && subscribedElement && subscribedElement.hasAttribute( 'data-pushpop-prevent-default' ) ) {
        var preventDefault  = parseBoolean( subscribedElement.getAttribute( 'data-pushpop-prevent-default' ) );
        if ( preventDefault ) {
            subscribedElement.onsubmit = function ( event ) {
                event.preventDefault();
            };
        }
    }

};

module.exports = {
    executeParamOptions: executeParamOptions,
    slugs: slugs,
    getSlugPath: getSlugPath,
    getPathName: getPathName,
    setRootPath: setRootPath,
    clearRootPath: clearRootPath,
    trackSlugs: trackSlugs
};


// Subscribe Methods to Events
inputEvents.push( pushpopInputEvents );
selectEvents.push( pushpopSelectEvents );
anchorOrButtonEvents.push( pushPopAnchorOrButtonEvents );
formEvents.push( pushpopForms );

// Add to front of pushstateChangeFunctions que
pushstateChange.unshift( removeDeadSlugs );
pushstateChange.push( updateSlugsFromPathname );

// Call update slugs when history state is replaced
replaceStateChange.unshift( removeDeadSlugs );
replaceStateChange.push( updateSlugsFromPathname );
